import { Injectable } from '@angular/core';
import { CallApiService } from 'src/app/shared/services/call-api.service';
import * as constants from '../../shared/helpers/constants';

@Injectable({
  providedIn: 'root'
})
export class ApprovalsService {

  constructor(
    private _CallApiService: CallApiService
  ) { }

  private SaveTpVoucher_url: string = constants.SaveTpVoucher_url;
  private get_employer_today_attendance_url: string = constants.get_employer_today_attendance_url;
  private SaveVoucher_url: string = constants.SaveVoucher_url;
  private SaveOtherLedgerCustomerSpecific_url:string=constants.SaveOtherLedgerCustomerSpecific_url;


  saveTpVoucher(userData: any) {
    return this._CallApiService.post_enc(userData, this.SaveTpVoucher_url);
  }
  get_employer_today_attendance(userData: any) {
    return this._CallApiService.post_enc(userData, this.get_employer_today_attendance_url);
  }

  SaveVoucher(userData: any) {
    return this._CallApiService.post_enc(userData, this.SaveVoucher_url);
  }

  SaveOtherLedgerCustomerSpecific(userData:any){
    return this._CallApiService.post_enc(userData, this.SaveOtherLedgerCustomerSpecific_url);
  }
private SaveAdvanceAndLoanVoucher_url: string = constants.SaveAdvanceAndLoanVoucher_url;
 SaveAdvanceAndLoanVoucher(userData: any) {
    return this._CallApiService.post_enc(userData, this.SaveAdvanceAndLoanVoucher_url);
  }


}
